import { render, staticRenderFns } from "./NewAccreditation.vue?vue&type=template&id=360bef3a&scoped=true"
import script from "./NewAccreditation.vue?vue&type=script&lang=js"
export * from "./NewAccreditation.vue?vue&type=script&lang=js"
import style0 from "./NewAccreditation.vue?vue&type=style&index=0&id=360bef3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360bef3a",
  null
  
)

export default component.exports